// extracted by mini-css-extract-plugin
export default {"box":"box__casak"};